import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromLocatorStore from 'src/app/locator-store/';
import * as fromUIStore from 'src/app/core/store';
import { PowerBiReportViewerService } from '../../../../services/report-viewer.service';
import { Subscription } from 'rxjs';
import { DialogWidth } from 'src/app/shared/atlas-dialog/enums/dialog-width.enum';
import { DialogService } from 'src/app/core/services/dialog.service';
import { delay, map } from 'rxjs/operators';
import { PowerBiReportTypes } from 'src/app/locator/types/power-bi-report.types';
import { LocatorReportingDialogComponent } from '../locator-reporting-dialog/locator-reporting-dialog.component';
import { LocatorPowerBiReportingInfo } from 'src/app/locator/models/locator-power-bi-reporting-info';
import { LocatorShape } from 'src/app/locator/models/locator-shape';
import { LocatorLibraryData } from 'src/app/locator/models/locator-library-data';
import { locatorLaunchReportingClicked } from 'src/app/locator-store/actions/locator-shape.actions';
import { LocatorReportTypes } from 'src/app/locator/types/locator-report.types';
import { triggerCreateSummaryStatsAttempt } from 'src/app/locator-store/actions/locator-summary-stats-actions';
import { openLocatorMultiCatchmentReportDialog } from 'src/app/locator-store/actions/locator-batch-reports.actions';

@Component({
  selector: 'atlas-locator-reports-panel-buttons',
  templateUrl: './locator-reports-panel-buttons.component.html',
  styleUrls: ['./locator-reports-panel-buttons.component.less'],
  standalone: false
})
export class LocatorReportsPanelButtonsComponent implements OnInit, OnDestroy {
  pbiReportList: LocatorPowerBiReportingInfo[] = [];
  selectedShapes: LocatorShape[] = [];

  reportDataAvailable: boolean;
  summaryStatsReportAvailable: boolean;
  showSummaryStatsReport: boolean;

  hasReportsForSelectedShapes$ = this.locatorStore$
    .select(fromLocatorStore.getSelectedShapes)
    .pipe(
      delay(100),
      map((selectedShapes) => {
        this.selectedShapes = selectedShapes ? selectedShapes : [];
        if (this.pbiReportList.length === 0) {
          return false;
        }
        return (
          this.selectedShapes.length === 1 ||
          (this.selectedShapes.length > 1 &&
            this.pbiReportList.some(
              (pbiReport) =>
                pbiReport.reportType === LocatorReportTypes.Multi_Shape
            ))
        );
      })
    );

  summaryStatsReportAvailable$ = this.locatorStore$
    .select(fromLocatorStore.getLocatorPowerBiReports)
    .pipe(
      map((pbiReportList) =>
        pbiReportList.some(
          (pbiReport) =>
            pbiReport.reportType === LocatorReportTypes.Summary_Stats
        )
      )
    );

  showSummaryStatsReport$ = this.UIStore$.select(
    fromUIStore.showSummaryStatsReport
  );

  areMultipleLocationsSelected$ = this.locatorStore$.select(
    fromLocatorStore.areMultipleLocationsSelected
  );

  private selectedLocationData: LocatorLibraryData | null;
  private subscription: Subscription = new Subscription();

  powerBiReportTypes = PowerBiReportTypes;

  constructor(
    private locatorStore$: Store<fromLocatorStore.State>,
    private UIStore$: Store<fromUIStore.State>,
    public powerBiReportViewerService: PowerBiReportViewerService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.locatorStore$
        .select(fromLocatorStore.getLocatorPowerBiReports)
        .subscribe((reports) => {
          this.pbiReportList = reports ? reports : [];
        })
    );
    this.subscription.add(
      this.locatorStore$
        .select(fromLocatorStore.getSelectedLocation)
        .subscribe((selectedLocationData) => {
          this.selectedLocationData = selectedLocationData;
        })
    );

    this.subscription.add(
      this.locatorStore$
        .select(fromLocatorStore.getIsReportDataAvailable)
        .subscribe((hasData) => {
          this.reportDataAvailable = hasData;
          this.cdr.detectChanges();
        })
    );

    this.subscription.add(
      this.summaryStatsReportAvailable$.subscribe(
        (summaryStatsReportAvailable) => {
          this.summaryStatsReportAvailable = summaryStatsReportAvailable;
        }
      )
    );

    this.subscription.add(
      this.showSummaryStatsReport$.subscribe(
        (showSummaryStatsReport) =>
          (this.showSummaryStatsReport = showSummaryStatsReport)
      )
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onLaunchReporting() {
    this.locatorStore$.dispatch(locatorLaunchReportingClicked());

    this.dialogService.show(LocatorReportingDialogComponent, {
      width: DialogWidth.Small,
      panelClass: 'dialog-full-width-height',
      data: {
        pbiReportList: this.pbiReportList,
        selectedLocationData: this.selectedLocationData,
        selectedShapes: this.selectedShapes,
        showSummaryStatsReport: this.showSummaryStatsReport
      },
      disableClose: true
    });
  }

  onLaunchSummaryReport() {
    this.locatorStore$.dispatch(triggerCreateSummaryStatsAttempt());
  }

  onLaunchBatchReport() {
    this.locatorStore$.dispatch(openLocatorMultiCatchmentReportDialog());
  }
}
